var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79447 17.5003C7.38208 18.019 8.15395 18.3337 8.99932 18.3337C9.8447 18.3337 10.6166 18.019 11.2042 17.5003M13.9993 6.66699C13.9993 5.34091 13.4725 4.06914 12.5349 3.13146C11.5972 2.19378 10.3254 1.66699 8.99932 1.66699C7.67324 1.66699 6.40147 2.19378 5.46379 3.13146C4.52611 4.06914 3.99932 5.34091 3.99932 6.66699C3.99932 9.24215 3.34972 11.0053 2.62404 12.1715C2.01193 13.1552 1.70587 13.6471 1.71709 13.7843C1.72952 13.9362 1.76171 13.9942 1.88414 14.085C1.99471 14.167 2.49315 14.167 3.49004 14.167H14.5086C15.5055 14.167 16.0039 14.167 16.1145 14.085C16.2369 13.9942 16.2691 13.9362 16.2816 13.7843C16.2928 13.6471 15.9867 13.1552 15.3746 12.1715C14.6489 11.0053 13.9993 9.24215 13.9993 6.66699Z",
    stroke: "#767C8F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.1be99c44b24b893a4da32c28a6b6e6df.svg";
export { ForwardRef as ReactComponent };